var render = function render(){var _vm=this,_c=_vm._self._c;return _c('fragment',[_c('div',{staticClass:"mouse-cursor cursor-outer"}),_c('div',{staticClass:"mouse-cursor cursor-inner"})])
}
var staticRenderFns = []

export { render, staticRenderFns }